import { useState } from "react";
import LzSApp from '@lz-app/App';
import useLzFApiCall from "@lz-services/Api";
import { useLzOnMount } from "@lz-services/Hooks";
import { lzFShowSuccessMessage } from "@lz-services/Utils";
import LzXSpinner from "@lz/components/commons/Spinner";
import LzXForm from "@lz-components/forms/Form";
import LzXInputField from '@lz-components/forms/fields/InputField';

const ConfigurationsScreen = (props) => {
    const [configs, setConfigs] = useState(null);
    const lzApiCall = useLzFApiCall();

    const load = async () => {
        const data = await lzApiCall('app-config');

        if (data && data.config) {
            setConfigs(data.config);
        }
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        const data = await lzApiCall('app-config', { configs: configs }, 'post');
        if (data) {
            lzFShowSuccessMessage('Configurations updated successfully!');
            return true;
        }
        return false;
    };

    const handleInputChange = (key, value) => {
        const updated = Object.assign({}, configs);
        updated[key] = value;
        setConfigs(updated);
    };

    // Call only for the first time when component is initially loaded
    useLzOnMount(() => {
        load();
    });

    if (!configs) {
        return <LzXSpinner />
    }

    return (
        <LzSApp.WrapperTemplate private screenTitle="Configurations">
            <div className={'lz-form-page lz-form-page-full lz-form-page-no-top-margin'}>

                <LzXForm
                    submitLabel="Save Changes"
                    onSubmit={handleFormSubmit}
                    cancelLabel="Reload"
                    onCancel={load}
                >
                    TODO: Change the below and input proper configs
                    <hr />

                    <LzXInputField
                        type="number"
                        name="t1" value={0}
                        onChange={handleInputChange}
                    />

                </LzXForm>

            </div>
        </LzSApp.WrapperTemplate>
    );

};

export default ConfigurationsScreen;
